import React from 'react';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer-main">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3 className="footer-title">Mental & Emotional Health</h3>
            <p className="footer-subtitle">in Today's Hybrid Warfare Environment</p>
            <p className="footer-author">By Daniel A. Stoescu</p>
          </div>
          
          <div className="footer-nav">
            <h4 className="footer-heading">Quick Links</h4>
            <button onClick={() => scrollToSection('home')} className="footer-link">Home</button>
            <button onClick={() => scrollToSection('about')} className="footer-link">About</button>
            <button onClick={() => scrollToSection('themes')} className="footer-link">Core Themes</button>
            <button onClick={() => scrollToSection('author')} className="footer-link">Author</button>
            <button onClick={() => scrollToSection('listen')} className="footer-link">Listen</button>
          </div>
          
          <div className="footer-info">
            <h4 className="footer-heading">About the Book</h4>
            <p className="footer-text">Published May 25, 2025</p>
            <p className="footer-text">AI-narrated Audiobook</p>
            <p className="footer-text">Genres: Self-help, Psychology, Science & Technology</p>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p className="footer-copyright">
            © 2025 Daniel A. Stoescu. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
